/**
 * Edit Controller
 */
(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.controller('AdvertiserEditController', [
    '$scope',
    '$window',
    'advertiserApi',
    'agencyApi',
    'optionsApi',
    function($scope, $window, advertiserApi, agencyApi, optionsApi) {
      // init values
      $scope.advertiser = {
        _id: null,
        agency_id: null,
        contacts: [],
        iab_category: '0',
      };

      $scope.log = {
        count: 0,
        data: [],
      };

      // load advertiser from server
      if ($window.advertiserId) {
        advertiserApi.read($window.advertiserId).then(
          function(data) {
            $scope.advertiser = data.advertiser;
            $scope.log = data.log;
          },
          function() {
            console.error('could not load advertiser');
          }
        );
      }

      // get agencies
      agencyApi.getList({field: 'id', 'order': 'asc'}, '', {number: 0, size: -1}).then(
        function(agencies) {
          $scope.agencies = [
            {
              name: "-",
              value: null
            }
          ];
          agencies.data.forEach(function(item) {
            $scope.agencies.push({
              name: item.name,
              value: item.id
            });
          });
        },
        function() {
          console.error('could not load agencies');
        }
      );

      // get iab categories
      optionsApi.getIab(true, true, true).then(
          function(iab) {
            $scope.iab = iab;
          },
          function() {
            console.error('could not load iab categories');
          }
      );

      $scope.$watch('advertiser.tmpLogo', function(newVal) {
        console.log(newVal);
        if (newVal) {
          $scope.advertiser.logo = null;
        }
      });

      $scope.quickComplete = function(name) {
        switch (name){
            case 'url':
                $scope.advertiser.url = 'https://www.dspx.tv';
                break;
            case 'logo':
                $scope.advertiser.logo = 'https://www.online-solution.biz/favicon.ico';
                break;
        }


      };

      // try saving and process server side validation errors
      $scope.submitForm = function() {
        !$scope.advertiser.url && $scope.quickComplete('url');
        !$scope.advertiser.logo && $scope.quickComplete('logo');

        if (!$scope.advertiserForm.$valid)
          return;

        advertiserApi.save($scope.advertiser).then(
          function() {
            $window.location.href = '/#!/demandmgr/advertiser';
          },
          function(data) {
              defaultSaveErrorHandler($scope.advertiserForm, data);
          }
        );
      };

      $scope.isNameUnique = function() {
        if (
          $scope.advertiserForm &&
          $scope.advertiserForm.hasOwnProperty('adv-name')
        ) {
          return !$scope.advertiserForm['adv-name'].$error.unique;
        }

        return true;
      };
    },
  ]);
})(window.angular);

/**
 * List Controller
 */
(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.controller('AdvertiserIndexController', [
    '$scope',
    '$timeout',
    'advertiserApi',
    function($scope, $timeout, advertiserApi) {
      // select search input content on focus
      $('#search').click(function() {
        $(this).select();
      });

      $scope.loading = false;

      $scope.list = null;


      $scope.page = {
        number: 0,
        size: 10,
      };

      $scope.searchTerm = '';

      $scope.sort = {
        field: 'ts_updated',
        order: 'desc',
      };

      var filterTimeout = null;
      $scope.$watch('searchTerm', function(newVal, oldVal) {
        if (newVal == oldVal) {
          return;
        }

        if (filterTimeout) {
          $timeout.cancel(filterTimeout);
        }

        filterTimeout = $timeout(function() {
          $scope.filter();
        }, 700);
      });


      $scope.filter = function() {
        $scope.page.number = 0;

        $scope.fetch();
      };

      /**
       * Fetch list data from server
       */
      $scope.fetch = function() {
        $scope.loading = true;

        advertiserApi
          .getList(
            $scope.sort,
            $scope.searchTerm,
            $scope.page
          )
          .then(
            function(data) {
              $scope.list = {
                count: data.count,
                data: data.data,
                maxPage: Math.floor(data.count / $scope.page.size),
              };
              $scope.loading = false;
            },
            function() {
              $scope.list = {
                count: 0,
                data: [],
                maxPage: null,
              };
              $scope.loading = false;
            }
          );
      };

      /**
       * set page to new value and load data
       * @param page
       */
      $scope.setPage = function(page) {
        $scope.page.number = page;

        $scope.fetch();
      };

      /**
       * get the sort css for a given column
       * @param field
       * @returns {*}
       */
      $scope.getSortCssClass = function(field) {
        if ($scope.sort.field === field) {
          return 'fa-sort-' + $scope.sort.order;
        } else {
          return 'fa-sort';
        }
      };

      /**
       * update sorting and fetch data
       * @param field
       */
      $scope.setSort = function(field) {
        $scope.page.number = 0;

        if ($scope.sort.field === field) {
          $scope.sort.order = $scope.sort.order === 'desc' ? 'asc' : 'desc';
        } else {
          $scope.sort.field = field;
          $scope.sort.order = 'desc';
        }

        $scope.fetch();
      };

      /**
       * show the delete confirmation dialog
       * @param advertiser
       */
      $scope.promptDelete = function(advertiser) {
        $scope.advertiserToDetele = advertiser;
        $('#delete-modal').modal('show');
      };

      /**
       * delete an IO
       * @param advertiser
       */
      $scope.delete = function(advertiser) {
        advertiserApi.delete(advertiser._id).then(function() {
          $scope.fetch();
        });
      };

      /**
       * export list to csv
       */
      $scope.export = function() {
        var url = '/demandmgr/advertiser/export' +
                  getReportUrl($scope.sort, $scope.searchTerm, {});
        window.location.href = url;
      };

      $scope.openAdvertiserForm = function(advertiserId) {
        window.location.href =
          '/#!/demandmgr/advertiser/edit?id=' + advertiserId;
      };

      $scope.canBeDeleted = function(advertiser) {
        // delete only if no IO or campaign has been assigned (even if IO or campaign is deleted)
        return advertiser['can_be_deleted'];
      };

      $scope.drillDown = function(id) {
        window.location.href = '/#!/demandmgr/insertion-order?advertiser=' + id;
      };

      $scope.fetch();
    },
  ]);
})(window.angular);
